export const handleBetInfo = (e) => {
  return {
    type: "HANDLE_BET_INFO",
    e,
  };
};
export const handleBet = (bet) => {
  return {
    type: "HANDLE_BET",
    bet,
  };
};
export const handleAutoRulesConfigs = (e) => {
  return {
    type: "HANDLE_AUTO_RULES_CONFIGS",
    e,
  };
};
export const handleAudio = (e) => {
  return {
    type: "HANDLE_AUDIO",
    e,
  };
};
export const handleSettings = (e) => {
  return {
    type: "HANDLE_SETTINGS",
    e,
  };
};
export const saveSettings = (e) => {
  return {
    type: "SAVE_SETTINGS",
    e,
  };
};
export const turnMode = (m) => {
  return {
    type: "TURN_MODE",
    m,
  };
};
export const toggleChangingMode = (e) => {
  return {
    type: "TOOGLE_CHANGINGMODE",
    e,
  };
};
export const handleBetReplay = (e) => {
  return {
    type: "HANDLE_BET_REPLAY",
    e,
  };
};
export const getSeedsResponce = (e) => {
  return {
    type: "GET_SEEDS_RESPONCE",
    e,
  };
};
export const handleGameState = (e) => {
  return {
    type: "GAME_STATE",
    e,
  };
};
